import { render, staticRenderFns } from "./VNav.vue?vue&type=template&id=30c114da&"
import script from "./VNav.vue?vue&type=script&lang=js&"
export * from "./VNav.vue?vue&type=script&lang=js&"
import style0 from "./VNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports